import { AccordionList } from "../../../../modules/content/components/AccordionList/AccordionList";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IAccordionBlockProps } from "./AccordionBlock.props";

export const AccordionBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  headingEffect,
  items,
  openBehavior,
  parentClass,
  spacing,
}: IAccordionBlockProps) => {
  if (!items?.length) return null;
  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-6">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:col-span-4"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingEffect={headingEffect}
          layout="stack"
          reveal
        />
        {/* `self-start` keeps the panel at its items' height. Left to stretch, it
            inherits the copy column's height and hangs a band of empty surface
            below the last question whenever the list is shorter than the copy. */}
        <div className="daylight-work-surface self-start rounded-[28px] p-3 lg:col-span-7 lg:col-start-6 lg:p-4">
          <AccordionList items={items} openBehavior={openBehavior} />
        </div>
      </div>
    </DaylightSection>
  );
};

AccordionBlock.displayName = "Block::AccordionBlock";
